import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { TaskviewPage } from './taskview.page';

const routes: Routes = [
  {
    path: '',
    component: TaskviewPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TaskviewPageRoutingModule {}
